import React from 'react';
import { string, number } from 'prop-types';

import * as helpers from './helpers';

const CodeIcon = ({ color, fillOpacity, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      fill={color}
      fillOpacity={fillOpacity}
      d="M9.0003 0C3.9803 0.04 -0.0397041 4.1 0.000295933 9.06C0.0402959 13.98 4.0603 18 9.0003 18H9.0603C11.4603 17.98 13.7203 17.04 15.4003 15.32C17.0803 13.6 18.0203 11.34 18.0003 8.94C17.9603 4.02 13.9403 0 9.0003 0ZM6.2403 11.54C6.4603 11.76 6.4603 12.14 6.2403 12.36C6.1203 12.48 5.9803 12.52 5.8403 12.52C5.7003 12.52 5.5403 12.46 5.4203 12.34L2.4803 9.4C2.2603 9.18 2.2603 8.8 2.4803 8.58L5.4003 5.62C5.6203 5.4 6.0003 5.4 6.2203 5.62C6.4403 5.84 6.4403 6.22 6.2203 6.44L3.7203 9L6.2403 11.54ZM10.5603 4.72L8.2403 13.58C8.1803 13.84 7.9403 14.02 7.6803 14.02C7.6403 14.02 7.5803 14.02 7.5403 14C7.2403 13.92 7.0403 13.6 7.1203 13.3L9.4403 4.44C9.5203 4.14 9.8403 3.94 10.1403 4.02C10.4603 4.1 10.6403 4.4 10.5603 4.72ZM15.5203 9.4L12.5803 12.36C12.4603 12.48 12.3203 12.54 12.1603 12.54C12.0203 12.54 11.8603 12.48 11.7603 12.38C11.5403 12.16 11.5403 11.78 11.7603 11.56L14.2803 9L11.7603 6.46C11.5403 6.24 11.5403 5.86 11.7603 5.64C11.9803 5.42 12.3603 5.42 12.5803 5.64L15.5203 8.6C15.7403 8.82 15.7403 9.18 15.5203 9.4Z"
    />
  </svg>
);

CodeIcon.propTypes = {
  color: string.isRequired,
  fillOpacity: number,
  ...helpers.iconDimensionsPropTypes,
};

CodeIcon.defaultProps = {
  fillOpacity: 1,
  ...helpers.getDefaultIconDimensionsProps(18, 18),
  ...helpers.getViewBoxProperty({ width: 18, height: 18 }),
};

export default CodeIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/code.js